module.exports = __webpack_public_path__ + "img/person_img.227d4b61.png";